import React from 'react'
import Registro from '../component/register/Registro'

const Register = () => {
  return <Registro />
}

export default Register